// TODO: try to replace with `[autofocus]`

up.compiler('[modal-input-autofocus]', (inputElement) => {

  function setFocus() {
    setTimeout(() => {
      inputElement.focus()
    }, 250)
  }

  // if the input element lies within a modal, we need to wait for it to finish opening
  up.on('up:layer:opened', () => {
    setFocus()
  })

  setFocus()
})
